/**
 * Created by eladd on 7/13/2017.
 */
import {ChangeDetectorRef, Component, EventEmitter, HostBinding, Input, Output} from "@angular/core";

@Component({
	selector: 'cp-tab',
	templateUrl: './tab.component.html',
	styles: [`
		 :host {
			 display: block;
			 height: calc(100% - 53px);
			 overflow: auto;
		 }

		 :host-context(cp-tabs-wrapper.short) {
			 height: calc(100% - 50px);
		 }

		 :host-context(cp-tabs-wrapper.classic) {
			 height: calc(100% - 35px);
		 }

		:host-context(cp-tabs-wrapper.vertical) {
			height: auto;
			width: calc(100% - 218px);
		}

		 :host-context(cp-tabs-wrapper.documents-wrapper) {
			 height: calc(100% - 39px);
		 }
	`]
})
export class TabComponent {
	@Input() tabTitle: string;
	@Input() iconClass: string;
	@Input() dontShowBaseTemplate:boolean = false;
	@Input() extraData:any; // used to pass custom data to the tab header
	@Input() hasChanges:boolean;
	@Input() disabled:boolean = false;
	@Input() invalid:boolean=false;
	@Input() specialStyle:{p:string, val:string};

	@Output() onActivation = new EventEmitter();
	@Output() onDeactivation = new EventEmitter();

	private _active: boolean;

	constructor(private cd:ChangeDetectorRef) {
	}

	get active(){
		return this._active;
	}

	// this is a try to resolve Bug 40487
	set active(active:boolean){
		this.cd.markForCheck();
		this._active=active;
	}

	@HostBinding('hidden') get notActive() {
		return !this.active;
	}
}
